import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import AppHeader from "../appHeader/appHeader";
import AppMenu from "../appMenu/appMenu";
import AppAdmin from "../appMenu/appAdmin";
import AppFooter from "../appFooter/appFooter";
import AppSetting from "../appSetting/appSetting";

/**
 * Este componente gerencia a exibição e remoção de usuários do portal.
 * Realiza a autenticação do usuário, busca a lista de usuários e clientes,
 * e permite a remoção de usuários através de um modal de confirmação.
 */
function Usuarios() {

    // Estados para gerenciar autenticação, dados do usuário, usuários e clientes
    const [authenticated, setAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [users, setUsers] = useState([]);
    const [clients, setClients] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    /**
     * useEffect para autenticação e obtenção dos dados de usuários e clientes.
     * Executa ao montar o componente.
     */
    useEffect(() => {
        // Função assíncrona para buscar usuários
        const fetchUsers = async () => {
            try {
                const response = await axios.post("/api/get/all/users", null, {
                    withCredentials: true,
                });
                if (response.data.status === 200) {
                    setUser(response.data.user);
                    setUsers(response.data.users);
                    setClients(response.data.client);
                    setAuthenticated(true);
                } else {
                    // Redireciona para a página de login se a autenticação falhar
                    window.location.href = "/login";
                }
            } catch (error) {
                console.error("Erro ao buscar usuários:", error);
                window.location.href = "/login";
            } finally {
                setIsLoading(false);
            }
        };

        // Chama a função para buscar usuários
        fetchUsers();
    }, []);

    /**
     * Função para remover um usuário.
     * Envia uma requisição para a API para remover o usuário pelo ID.
     * @param {number} id - ID do usuário a ser removido
     */
    const removeUser = async (id) => {
        try {
            const response = await axios.post(`/api/remove/user/${id}`, null, {
                withCredentials: true,
            });
            if (response.data.status === 200) {
                // Atualiza a lista de usuários após remoção bem-sucedida
                setUsers((prevUsers) =>
                    prevUsers.filter((user) => user.id !== id)
                );
                // Fecha o modal de confirmação
                setSelectedUserId(null);
            } else {
                alert(response.data.msg || "Erro ao remover usuário.");
            }
        } catch (error) {
            console.error("Erro ao remover usuário:", error);
            alert(
                "Ocorreu um erro ao remover o usuário. Por favor, tente novamente."
            );
        }
    };

    /**
     * Função para selecionar o ID do usuário a ser removido.
     * @param {number} id - ID do usuário
     */
    const setIdClient = (id) => {
        setSelectedUserId(id);
    };

    // Estilos para o spinner de carregamento
    const spinnerStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
    };

    /**
     * Renderiza o spinner de carregamento enquanto os dados estão sendo buscados.
     */
    if (isLoading) {
        return (
            <div style={spinnerStyle}>
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    /**
     * Verifica se o usuário está autenticado.
     * Caso contrário, redireciona para a página de login.
     */
    if (!authenticated) {
        window.location.href = "/login";
        return null;
    }
    /**
     * Renderiza o componente para administradores.
     */
    if (user && user.id === 1) {
        return (
            <>

                {/* Cabeçalho da Página */}
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Consultar Usuários</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <a href="/">Início</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Consultar Usuários
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Conteúdo Principal */}
                <section className="content">
                    <div className="container-fluid" style={{ marginTop: 18 }}>
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12">
                                                <div className="white-box">
                                                    <div className="tab-content">
                                                        {/* Tabela de Usuários */}
                                                        <table
                                                            id="example1"
                                                            className="table table-bordered table-striped dataTable dtr-inline"
                                                            aria-describedby="example1_info"
                                                        >
                                                            <thead>
                                                                <tr>
                                                                    <th
                                                                        style={{
                                                                            width: 10,
                                                                        }}
                                                                    >
                                                                        #
                                                                    </th>
                                                                    <th>
                                                                        Nome
                                                                    </th>
                                                                    <th>
                                                                        Empresa
                                                                    </th>
                                                                    <th
                                                                        style={{
                                                                            width: 100,
                                                                        }}
                                                                    >
                                                                        Ações
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {users.map(
                                                                    (
                                                                        dados,
                                                                        index
                                                                    ) => (
                                                                        <tr
                                                                            key={
                                                                                dados.id
                                                                            }
                                                                        >
                                                                            <td>
                                                                                {index +
                                                                                    1}
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    dados.nome
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {clients[
                                                                                    index
                                                                                ]
                                                                                    ?.nome ||
                                                                                    "N/A"}
                                                                            </td>
                                                                            <td>
                                                                                <button
                                                                                    className="btn btn-danger"
                                                                                    data-toggle="modal"
                                                                                    data-target="#deleteUser"
                                                                                    onClick={() =>
                                                                                        setIdClient(
                                                                                            dados.id
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <i className="fa fa-trash"></i>
                                                                                </button>
                                                                                <a
                                                                                    href={`/usuario/${dados.id}`}
                                                                                >
                                                                                    <button className="btn btn-info ml-2">
                                                                                        <i className="fa fa-edit"></i>
                                                                                    </button>
                                                                                </a>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Modal de Confirmação de Remoção */}
                <div
                    className="modal fade"
                    id="deleteUser"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="deleteUserLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-sm" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5
                                    className="modal-title"
                                    id="deleteUserLabel"
                                >
                                    Deseja mesmo excluir este usuário?
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-6 text-center">
                                        <button
                                            className="btn btn-danger"
                                            onClick={() =>
                                                removeUser(selectedUserId)
                                            }
                                        >
                                            Sim
                                        </button>
                                    </div>
                                    <div className="col-6 text-center">
                                        <button
                                            className="btn btn-primary"
                                            data-dismiss="modal"
                                        >
                                            Não
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Select2 Placeholder (se necessário) */}
                <select className="select2" style={{ display: "none" }} />
            </>
        );
    }
}

export default Usuarios;
